import {
  endOfMonth,
  endOfToday,
  endOfTomorrow,
  endOfWeek,
  endOfYesterday,
  startOfToday,
} from "date-fns";
import i18next from "i18next";

export const colors = {
  primary: "#244E66",
  dark: "#2c2c2d",
  gold: "rgba(255, 211, 125, 0.8)",
  goldAccent: "#e8bf55",
  goldDark: "rgba(182, 139, 55, 0.8)",
  gray: "#eeeeee",
  greyBorder: "#e5e5e5",
  signatureBorder: "#CECECE",
  white: "#fff",
  white20: "rgba(255, 255, 255, 0.2)",
  black: "#000",
  black80: "rgba(44, 44, 45, 0.8)",
  black60: "rgba(44, 44, 45, 0.6)",
  black40: "rgba(44, 44, 45, 0.4)",
  black20: "rgba(44, 44, 45, 0.2)",
  black5: " rgba(44, 44, 45, 0.05)",
  black3: "rgba(44, 44, 45, 0.03)",
  green: "#66765b",
  greenLight: "#cce7bb",
  red: "#7a4a4a",
  redLight: "#e2abab",
  textPrimary: "#2c2c2d",
  textSecondary: "gray",
  textGold: "rgba(182, 139, 55, 0.8)",
  outline: "rgba(44, 44, 45, 0.05)",
  text_gold: "#b68b37",
  goldNoRgba: "#b68b37cc",
  votingSummaryBg: "rgba(182, 139, 55, 0.1)",
};

export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints["video"] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

export const SELECTED_AUDIO_INPUT_KEY = "TwilioVideoApp-selectedAudioInput";
export const SELECTED_AUDIO_OUTPUT_KEY = "TwilioVideoApp-selectedAudioOutput";
export const SELECTED_VIDEO_INPUT_KEY = "TwilioVideoApp-selectedVideoInput";

export const GALLERY_VIEW_ASPECT_RATIO = 9 / 16; // 16:9
export const GALLERY_VIEW_MARGIN = 3;

export const today = new Date();
export const startToday = startOfToday().toISOString();
export const endToday = endOfToday().toISOString();
export const endTomorrow = endOfTomorrow().toISOString();
export const endWeek = endOfWeek(today, { weekStartsOn: 1 }).toISOString();
export const endMonth = endOfMonth(today).toISOString();
export const overdue = endOfYesterday().toISOString();

// export const phoneRegExp =
//   /^(\+48|0048|48)? ?[0-9]{3} ?[0-9]{3} ?[0-9]{3}$|^\+1 ?[0-9]{3} ?[0-9]{3} ?[0-9]{4}$|^\+966 ?[0-9]{9}$/;
export const phoneRegExp = /^(\+9665\d{8}|\+9715\d{8}|\+923\d{9})$/;

export const currentLanguage =
  JSON.parse(String(localStorage.getItem("lang"))) || i18next.language || "ar";

export const descriptionCharactersMax = 2000;

export const dateFormats = {
  main: "dd.MM.yyyy",
};

export enum Language {
  ar = "ar",
  en = "en",
}

export const templateCategories = [
  { label: "All", value: "-1" },
  { label: "Drafts", value: "0" },
  { label: "Committee meetings", value: "1" },
  {
    label: "Financial Performance Report",
    value: "2",
  },
  { label: "Executive Appointment", value: "3" },
  { label: "Compliance Review", value: "4" },
  { label: "Profit Distribution", value: "5" },
  { label: "Subcommittee Meeting", value: "6" },
  {
    label: "Review of Financial Reports",
    value: "7",
  },
  {
    label: "Risk and Compliance Analysis",
    value: "8",
  },
  { label: "Compensation Committee", value: "9" },
  { label: "Appointment of New Members", value: "10" },
  { label: "Incentive Policies", value: "11" },
  { label: "Emergency Decisions", value: "12" },
  { label: "Corporate Restructuring", value: "13" },
];
